<template>
  <div>

    <!-- 店铺详情 -->
    <cube-page :title="isAdd ? '新增' : '编辑'">
      <div slot="content">
        <div class="shopxq leopages">
          <van-form @submit="onSubmit">
            <van-field v-model="entry.team_name" clearable label="团队名称" placeholder="请输入团队名称" name="team_name" required
              :rules="[{ required: true, message: '请填写团队名称' }]" />
            <van-field required readonly clickable name="picker" :value="textList.team_type" label="团队类型"
              placeholder="点击选择团队类型" :rules="[{ required: true, message: '请选择团队类型' }]"
              @click="showPickerFun('team_type')" />
            <van-field required readonly clickable name="datetimePicker" :value="entry.start_time" label="出团时间"
              placeholder="点击选择出团时间" @click="showPickerFunTime('start_time')"
              :rules="[{ required: true, message: '请选择出团时间' }]" />
            <van-field required readonly clickable name="datetimePicker" :value="entry.end_time" label="完团时间"
              placeholder="点击选择完团时间" @click="showPickerFunTime('end_time')"
              :rules="[{ required: true, message: '请选择完团时间' }]" />
            <van-field v-model="entry.total_price" clearable label="价格" placeholder="请输入价格" name="team_name" required
              :rules="[{ required: true, message: '请填写价格' }]" type="number" />
            <van-field v-model="entry.team_number" clearable label="人数" placeholder="请输入人数" name="team_name" required
              :rules="[{ required: true, message: '请填写人数' }]" type="number" />
            <van-field required readonly clickable name="picker" :value="textList.guide_rank" label="职级要求"
              placeholder="点击选择职级" @click="showPickerFun('guide_rank')"
              :rules="[{ required: true, message: '请选择职级' }]" />
            <van-field required name="checkboxGroup" label="语种要求" :rules="[{ required: true, message: '请选择语种' }]">
              <template #input>
                <van-checkbox-group v-model="textList.lang" direction="horizontal">
                  <van-checkbox v-for="item in pickerList['lang']" :key="item.value" :name="item.value"
                    shape="square">{{ item.text }}</van-checkbox>
                </van-checkbox-group>
              </template>
            </van-field>
            <van-field required readonly clickable name="picker" :value="textList.gender" label="性别要求"
              placeholder="点击选择性别" @click="showPickerFun('gender')" :rules="[{ required: true, message: '请选择性别' }]" />
            <van-field required readonly clickable name="picker" :value="textList.age" label="年龄要求" placeholder="点击选择年龄"
              @click="showPickerFun('age')" :rules="[{ required: true, message: '请选择年龄' }]" />
            <van-field required name="checkboxGroup" label="技能要求" :rules="[{ required: true, message: '请选择技能要求' }]">
              <template #input>
                <van-checkbox-group v-model="textList.skill" direction="horizontal">
                  <van-checkbox v-for="item in pickerList['skill']" :key="item.value" :name="item.value"
                    shape="square">{{ item.text }}</van-checkbox>
                </van-checkbox-group>
              </template>
            </van-field>
            <van-field v-model="entry.trip_text" show-word-limit rows="2" autosize maxlength="500" type="textarea"
              clearable label="行程" placeholder="请输入行程 如：早上:XXXXX 中午:XXXXX" name="team_name" required
              :rules="[{ required: true, message: '请填写行程' }]" />
            <div style="margin: 16px;">
              <van-button round block type="info" native-type="submit" :loading="loading">提交</van-button>
            </div>
          </van-form>
        </div>
      </div>
    </cube-page>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker :title="pickerTitleActive" show-toolbar :columns="columns" @confirm="onConfirm"
        @cancel="showPicker = false" />
    </van-popup>
    <van-popup v-model="showPickerTime" position="bottom">
      <van-datetime-picker v-model="currentDate" type="datetime" @confirm="onConfirmTime"
        @cancel="showPickerTime = false" />
    </van-popup>
  </div>
</template>

<script>
import {
  Toast
} from 'vant';
import CubePage from '../../TP/cube-page.vue'
import * as util from '@/utils/network'
import * as udate from "@/utils/date";

export default {
  components: {
    CubePage,
  },
  data() {
    return {
      isAdd: true,
      entry: {
        team_name: '', //	团队名称
        team_type: '', //团队类型:10=纯玩,20=假纯,30=购物团,40=vip团,99=其他
        start_time: '', //	出团时间
        end_time: '', //		完团时间
        total_price: '', // 价格
        team_number: '', // 人数
        trip_text: '', //	行程,
        guide_rank: '',// 职级要求:10=初级,20=中级,30=高级,40=金牌,99=不限制
        lang: [],//语种要求:10=国语,11=英语,12=日语,13=韩语,14=德语,15=泰语,16=俄语,99=不限制
        gender: '',//性别要求:10=男,20=女,30=不限制
        age: '',//年龄要求:10=20~30,20=31~40,30=41~50,99=不限制
        skill: [],//技能要求:10=文博,11=亲子,12=山水,13=旅拍,14=情感,15=才艺,16=颜值,99=不限制
        id: '',
      },
      pickerList: {
        team_type: [],
        guide_rank: [],
        lang: [],
        gender: [],
        age: [],
        skill: []
      },
      showPicker: false,
      objkey: '',
      columns: [],
      textList: {
        team_type: '',
        guide_rank: '',
        lang: [],
        gender: '',
        age: '',
        skill: [],
      },
      pickerTitle: {
        team_type: '团队类型',
        guide_rank: '职级',
        lang: '语言',
        gender: '性别',
        age: '年龄',
        skill: '技能'
      },
      pickerTitleActive: '',
      showPickerTime: false, // 时间选择器
      currentDate: new Date(),
      loading: false
    }
  },
  methods: {
    // 提交
    onSubmit() {
      this.loading = true;
      let { skill, lang } = this.textList; // 技能和语言
      this.entry.skill = skill.join(',');
      this.entry.lang = lang.join(',');
      let url = "/addons/litestore/api.distributor/reserveSave"
      //这里直接调用网络接口
      util.post(url, this.entry, (result) => {
        Toast(result.msg);
        this.loading = false;
        if (result.code == 1) {
          util.redirect('travelOrder');
        }
      });
      setTimeout(() => {
        this.loading = false;
      }, 3000)
    },
    // 初始化
    getData(onlyid) {
      let url = "/addons/litestore/api.distributor/reserveSave";
      util.get(url, {
        id: onlyid ? onlyid : ''
      }, (result) => {
        if (result.data != null) {
          this.isAdd = false
          let { team_name, team_type, team_type_text, start_time, end_time, total_price, team_number, trip_text, guide_rank, guide_rank_text, lang, gender, gender_text, age, age_text, skill, id } = result.data;
          lang = lang.split(',').map(Number);
          skill = skill.split(',').map(Number);
          let textListNew = {
            team_type: team_type_text, //团队类型
            guide_rank: guide_rank_text, // 职级要求
            lang,//语种要求
            gender: gender_text,//性别要求
            age: age_text,//年龄要求
            skill,//技能要求
          };
          this.textList = textListNew;
          let obj = {
            team_type: Number(team_type),
            guide_rank: Number(guide_rank),
            lang,
            gender: Number(gender),
            age: Number(age),
            skill,
            team_name, //	团队名称
            start_time, //	出团时间
            end_time, //		完团时间
            total_price, // 价格
            team_number, // 人数
            trip_text, //	行程,
            id
          };
          this.entry = obj;
        }
      });
    },
    // 下拉其它选项
    showPickerFun(type) {
      this.showPicker = true;
      this.objkey = type;
      this.columns = this.pickerList[type];
      this.pickerTitleActive = this.pickerTitle[type];
    },
    // 确认选中其它选项
    onConfirm(val) {
      this.entry[this.objkey] = val.value;
      this.textList[this.objkey] = val.text;
      this.showPicker = false;
    },
    // 时间选项
    showPickerFunTime(type) {
      this.objkey = type;
      this.showPickerTime = true;
    },
    // 时间选择器确认
    onConfirmTime(value) {
      let dqdate = udate.getFormatDate(value, 'yyyy-mm-dd MM:mm'); // 返回日期格式
      this.currentDate = new Date(value);
      this.entry[this.objkey] = dqdate;
      this.showPickerTime = false;
    },
    getListSetting() {
      //http://www.shop.lol/addons/litestore/api.distributor/getSetList?token=9c9b6678-92ec-42a2-879a-53ad4a5405ef&id=4
      let url = "/addons/litestore/api.distributor/getSetList";
      util.get(url, {}, (res) => {
        if (res.code == 1) {
          let { age_list, gender_list, lang_list, rank_list, skill_list, type_list } = res.data;
          this.pickerList = {
            team_type: type_list,
            guide_rank: rank_list,
            lang: lang_list,
            gender: gender_list,
            age: age_list,
            skill: skill_list
          }
        }
      })
    }
  },
  created() {
    this.getListSetting();
    let id = this.$route.query.id;
    if (id) {
      this.isAdd = false;
      this.getData(id)
    }
  }
}
</script>
<style type="text/css" lang="less">
.van-form {
  background-color: #FFFFFF;
  padding: 20px 0;

  .tk {
    font-size: 12px;
    text-align: center;

    a {
      color: #000;
    }

    .van-field__control:read-only {
      justify-content: center !important;
    }
  }
}

.van-nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.van-hairline--bottom::after {
  border-bottom-width: 0px;
}

.height100 {
  height: 100vh;
}

.flex-column-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.vue-cropper {
  background: #000 !important;

  .cropper-view-box {
    outline: 1px solid #fff !important;
    outline-color: #fff !important;
  }
}

.footerB {
  background: #000 !important;
  padding: 10px 15px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .fitem {
    color: #FFFFFF;
    // width:50px;
  }
}

.vanfield {
  .van-field__value {
    flex: none;
  }

  .van-icon-success {
    border-radius: 4px;
  }
}

.van-checkbox {
  margin-bottom: 10px;
}
</style>
